import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { changePassword } from '../../actions/user';

import { Input } from '../../components/Inputs';
import StatusMessages from '../../components/StatusMessages';

class ChangePassword extends Component {

    constructor(props){
        super(props);

        this.state = {
            user: {
                email: this.props.user.userInfo.email,
                newpwd: "",
                newpwd2: "",
                oldpwd: ""
            },
            has_errors: false,
            isSubmitted: false
        }

        this.onChange = this.onChange.bind(this);
        this.changePassword = this.changePassword.bind(this);
    }

    changePassword = (e) => {
        e.preventDefault();
        const { user } = this.state;

        this.props.changePassword(user);
    }

    onChange = (e) => {
        e.preventDefault();
        const { user } = this.state
        const { name, value } = e.target;

        this.setState({
            user: {
                ...user,
                [name]:value
            }
        });
    }

    render(){

        const {  has_errors } = this.state;
        const { user } = this.props;

        return(
            <div className="clearfix col-sm-12">
                {
                    user.error ?
                        <StatusMessages type="error" message={ user.errorMessage.error } />
                    : null
                }
                {
                    user.success ?
                        <StatusMessages type="success" message={ user.successMessage } />
                    : null
                }

				<form name="regfrm" onSubmit={ this.changePassword }>

					<Input 
						showError={ has_errors }
						name="oldpwd"
						label="Old Password" 
						placeholder="Old Password"
						type="password"
						validations={ ['required', 'oldpwd'] }
						value={ user.oldpwd }
                        onChangeFn={ this.onChange } />
                        
                    <Input 
						showError={ has_errors }
						name="newpwd"
						label="New Password" 
						placeholder="New Password"
						type="password"
						validations={ ['required', 'oldpwd'] }
						value={ user.newpwd }
                        onChangeFn={ this.onChange } />
                        
                    <Input 
						showError={ has_errors }
						name="newpwd2"
						label="Confirm New Password" 
						placeholder="Confirm New Password"
						type="password"
						validations={ ['required', 'oldpwd'] }
						value={ user.newpwd2 }
						onChangeFn={ this.onChange } />
					
					
					<div className="form-group">
						<button type="submit" className="btn btn-warning">
                            Change Password
                        </button>
					</div>
				</form>
			</div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    user: state.user
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ changePassword }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);


// WEBPACK FOOTER //
// ./src/pages/auth/ChangePassword.js